module.exports = __webpack_public_path__ + "media/student_finance/personal-finance_rollover-8df955d5.jpg";